ixModuleRouting("impactx.download", {
    "/attachmentredirect/:baseObject/:baseUrl*": {
        template: "<ixa-attachment-redirect></ixa-attachment-redirect>",
        templateUrl: "shared/download/templates/attachmentredirect.html",
        controller: "AttachmentRedirectCtrl",
        controllerAs: "attachmentRedirectCtrl",
        process: "Search",
        workspace: "shop",
    },
});
